import type { FC, ReactNode } from 'react'

import { useEffect, useRef } from 'react'
import { AnimatePresence } from 'motion/react'
import { useLenis } from '@/components/generals/smooth-scroll'
import { Header } from '@/components/generals/header'
import { Cursor } from '@/components/generals/cursor'
import { ViewfinderIntro } from '@/components/generals/viewfinder-intro'
import { PageTransition } from '@/components/generals/page-transition'

interface SiteFrameProps {
    routeKey: string
    children: ReactNode
}

export const SiteFrame: FC<SiteFrameProps> = ({ routeKey, children }): ReactNode => {
    const lenis = useLenis()
    const firstRoute = useRef(routeKey)
    const navigated = useRef(false)

    if (routeKey !== firstRoute.current) navigated.current = true

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }
    }, [])

    const resetScroll = () => {
        lenis?.scrollTo(0, { immediate: true, force: true })
        window.scrollTo(0, 0)
    }

    return (
        <>
            <Header />

            <AnimatePresence mode='wait' onExitComplete={resetScroll}>
                <PageTransition key={routeKey} arrival={!navigated.current}>
                    {children}
                </PageTransition>
            </AnimatePresence>

            <Cursor />
            <ViewfinderIntro />

            <div aria-hidden='true' className='grain' />
        </>
    )
}
